/**
 * Created by Victor Rojo on 18/2/20.
 */
import { Component, Input, OnDestroy, ViewChild, ElementRef,
  AfterContentInit, HostListener, Renderer2 }     from '@angular/core';

import { interval ,  Unsubscribable as AnonymousSubscription }             from "rxjs";

import * as Videojs from "video.js";

import {Globals} from "../../globals";
import {I18NService} from "../../shared/i18n/i18n.service";
import {SurveillanceService} from "./Surveillance.service";
import {SurveillanceCamera} from "./SurveillanceCamera";

@Component({
  selector: "surveillance-camera-streaming",
  templateUrl: './SurveillanceCameraStreaming.component.html',
  styleUrls: ['./SurveillanceCameraStreaming.component.css']
})
export class SurveillanceCameraStreamingComponent {

  _camera: SurveillanceCamera;

  src = "";
  isLoading = true;
  attempt = 1;
  maxAttempts = 5;
  selected:any = null;
  player:any;
  @ViewChild('video', { static: true }) video: ElementRef;
  private interval: AnonymousSubscription;
  private curentTime: number;
  private curentTimeCheck: number;

  private retryTimeout:any;
  private _streamingActive = true;

  constructor(private renderer: Renderer2) {
    this.interval = interval(10000).subscribe(() => {
      if ( this._streamingActive && this.player
        && this.player.tech({ IWillNotUseThisInPlugins: true }
          && this.player.tech({ IWillNotUseThisInPlugins: true }).hls )) {
        let playerCurrentTime = this.player.tech({ IWillNotUseThisInPlugins: true }).hls.stats.currentTime;
        if ( this.curentTime !=  playerCurrentTime ) {
          this.curentTime =  playerCurrentTime;
          this.attempt = 1;
          this.curentTimeCheck = new Date().getTime();
        } else if ( !this.isLoading && this.attempt < this.maxAttempts && new Date().getTime() - this.curentTimeCheck > 20000) {
          this.selectStreaming(this.selected);
        }
      }
    });
  }

  get camera(): SurveillanceCamera {
    return this._camera;
  }

  @Input()
  set camera(camera: SurveillanceCamera) {
    this._camera = camera;
    this.startStreaming();
  }



  public streamingActive(active: boolean) {
    if ( active && !this._streamingActive ) {
      this.startStreaming();
      this._streamingActive = true;
    } else if ( !active && this._streamingActive ) {
      this.cancelStreaming();
      this.isLoading = false;
      this._streamingActive = false;
    }
  }

  private startStreaming() {
    let id = "player" + this._camera.cameraId;
    let video = this.renderer.createElement('video');
    this.renderer.setAttribute(video, "id", id);
    this.renderer.appendChild(this.video.nativeElement, video);
    let videojs = Videojs.default;
    this.player = videojs(id, {
      autoplay: 'muted',
      children: []
    });
    var self = this;
    this.player.on("loadedmetadata", function(){
      self.isLoading = false;
    });
    this.selectStreaming(this._camera);
  }

  selectStreaming(camera:any) {
    this.isLoading = true;
    this.attempt = 1;
    this.curentTime = 0;
    this.curentTimeCheck = 0;

    this.src = "api/v1/camera/" + camera.cameraId + "/playlist.m3u8";

    this.player.src({
      src: this.src,
      type: 'application/x-mpegURL'
    });
    this.selected = camera;
    this.retryIfNotLoaded();
  }


  manualReconnect(){
    this.selectStreaming(this._camera);
  }

  retryIfNotLoaded() {
    if ( this.retryTimeout != null ) {
      clearTimeout(this.retryTimeout);
      this.retryTimeout = null;
    }
    this.retryTimeout = setTimeout(()=>{
      this.retryTimeout = null;
      if ( this.isLoading && this.attempt < this.maxAttempts && this.player.player() ) {

        this.player.src({
          src: this.src,
          type: 'application/x-mpegURL'
        });

        this.attempt++;
        this.retryIfNotLoaded();
      } else if ( this.attempt >= this.maxAttempts ) {
        this.isLoading = false;
      }
    }, 5000);
  }

  snapshot(){
    if ( !this.isLoading ) {
      var c = document.createElement('canvas');
      let videoElement = this.player.$("video");

      c.width = videoElement.videoWidth;
      c.height = videoElement.videoHeight;
      var ctx = c.getContext('2d');

      ctx.drawImage(videoElement, 0, 0);

      var link = document.createElement('a');
      link.setAttribute('download', this.selected.name + new Date().toLocaleString() + '.png');
      link.setAttribute('href', c.toDataURL("image/png").replace("image/png", "image/octet-stream"));
      link.click();
    }
  }

  cancelStreaming(){
    if ( this.player ) {
      this.player.dispose();
    }
  }

  public ngOnDestroy(): void {
    this.cancelStreaming();
    if ( this.interval ) {
      this.interval.unsubscribe()
    }
  }

}
